/** OCR configuration sections, in the order they appear as chips. */
export type OcrSection = "ocr_fields" | "ocr_stop_factors";

export const OCR_SECTIONS: OcrSection[] = ["ocr_fields", "ocr_stop_factors"];

export const isOcrSection = (value: unknown): value is OcrSection =>
	OCR_SECTIONS.includes(value as OcrSection);
